import { render, staticRenderFns } from "./new-subbucket-folder.html?vue&type=template&id=0d3ef4a6&scoped=true&external"
import script from "./new-subbucket-folder.js?vue&type=script&lang=js&external"
export * from "./new-subbucket-folder.js?vue&type=script&lang=js&external"
import style0 from "./new-subbucket-folder.scss?vue&type=style&index=0&id=0d3ef4a6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3ef4a6",
  null
  
)

export default component.exports